<ng-container>
  <!-- <ul class="nav nav-tabs">
    @for (tab of tabNames | keyvalue; track tab) {
      <li class="nav-item" (click)="changeTab(tab.value)">
        <a
          class="nav-link"
          data-toggle="tab"
          [ngClass]="selectedTab === tab.value ? 'active' : ''"
          >{{ tab.value }}</a
        >
      </li>
    }
  </ul> -->

  @if (incidentCountStats?.incident_count > 5) {
    <div class="my-3 col-12 col-lg-6">
      <gtapp-auto-complete
        [data]="incidentDropDownList"
        placeHolder="Search Incidents"
        searchKeyword="name"
        [initialValue]="globalFilter"
        [itemTemplate]="incidentLookupTemplate"
        (inputChanged)="onIncidentLookup($event)"
        (selected)="onSelectIncident($event)"
        (submitted)="
          globalFilter = $event; selectedFilter = 'all'; getIncidents()
        "
        [enableSearchCloseOption]="true"
        (fieldCleared)="globalFilter = null; getIncidents()"
      >
      </gtapp-auto-complete>
      <ng-template #incidentLookupTemplate let-item>
        <div>
          <span class="fw-semibold">
            {{ item?.site_name }}
          </span>
          <span> [{{ item?.company_name }}] </span>
        </div>
        <div>
          {{ item?.incident_key }} [{{
            item?.status == 0
              ? item?.submitted_at
                ? "Logged"
                : "Open"
              : "Closed"
          }}]
        </div>
        <div class="small-font text-secondary">
          {{ item?.full_address }}
        </div>
      </ng-template>
    </div>
  }
</ng-container>

@if (
  incidentCountStats?.incident_count != incidentCountStats?.total_count ||
  selectedFilter !== "default"
) {
  <div class="d-flex justify-content-start me-2 mb-2">
    <div class="d-flex btn-group">
      <button
        class="btn fw-semibold px-3 btn-sm"
        [ngClass]="
          selectedFilter === 'default'
            ? 'btn-primary'
            : 'btn-outline-primary bg-white'
        "
        (click)="filterIncidents('default')"
      >
        In Progress
      </button>

      @if (
        (isAdmin || isDispatchUser) &&
        largeView &&
        incidentCountStats?.incident_count -
          (incidentCountStats?.open_count + incidentCountStats?.review_count) >
          0
      ) {
        <button
          class="btn fw-semibold px-3 btn-sm"
          [ngClass]="
            selectedFilter === 'closed'
              ? 'btn-primary'
              : 'btn-outline-primary bg-white'
          "
          (click)="filterIncidents('closed')"
        >
          Complete
        </button>
      }

      <button
        class="btn fw-semibold px-3 btn-sm"
        [ngClass]="
          selectedFilter === 'all'
            ? 'btn-primary'
            : 'btn-outline-primary bg-white'
        "
        (click)="filterIncidents('all')"
      >
        Show All
      </button>
    </div>
  </div>
}
<div class="add-button-padding">
  @if (largeView) {
    <ng-container>
      <!-- Table View for Desktop -->
      <gtapp-gt-custom-table
        [deskTopTableData]="incidentListData"
        [desktopTableDetails]="incidentListTableDetails"
        [otherParams]="otherParamsIncidents"
        (sortColumn)="sortColumnIncident($event)"
        (searchColumn)="searchColumnIncident($event)"
        (rowClick)="onSelectIncident($event)"
        (paginationChange)="onChangePaginationIncident($event)"
      >
      </gtapp-gt-custom-table>
    </ng-container>
  } @else {
    <ng-container>
      <!-- Card List for Mobile View -->
      <gtapp-card-list
        [mobileCardBackendData]="incidentListData"
        [mobileCardDetails]="incidentCardDetails"
        (rowClick)="onSelectIncident($event)"
        [otherParams]="otherParamsIncidents"
        (sortColumn)="sortColumnIncident($event)"
        (rowClick)="onSelectIncident($event)"
        (paginationChange)="onChangePaginationIncident($event)"
      ></gtapp-card-list>
    </ng-container>
  }
</div>
<div class="mt-1 mx-1">
  <div class="fixed-add-btn">
    <button class="btn btn-primary btn-lg w-100" (click)="addIncident()">
      <span><i class="fa-solid fa-plus"></i></span>
    </button>
  </div>
</div>
